module.exports = __webpack_public_path__ + "videos/3d-export_en.1f4627b.mp4";